import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-notification-badge',
  templateUrl: './notification-badge.component.html',
  styleUrls: ['./notification-badge.component.scss'],
  standalone: false,
})
export class NotificationBadgeComponent implements OnInit, OnDestroy {
  isVisible = false;
  isClosing = false;
  private readonly STORAGE_KEY = 'notification_new_style_count';
  private readonly MAX_VIEWS = 3;
  private autoCloseTimeout: any;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    const viewCount = parseInt(localStorage.getItem(this.STORAGE_KEY) || '0');

    if (viewCount < this.MAX_VIEWS) {
      setTimeout(() => {
        this.isVisible = true;
        this.cdr.detectChanges();

        localStorage.setItem(this.STORAGE_KEY, (viewCount + 1).toString());

        this.autoCloseTimeout = setTimeout(() => {
          this.close();
        }, 12000);
      }, 1000);
    }
  }

  close() {
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
    }

    this.isClosing = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.isVisible = false;
      this.isClosing = false;
      this.cdr.detectChanges();
    }, 300);
  }

  ngOnDestroy() {
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
    }
  }
}
